/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { Icon } from "PFComponents/icon";

import css from "./chat.module.scss";

type ChatMinimizedActionsProps = {
  unreadCount: number;
  onClose: (event?: React.SyntheticEvent) => void;
};

export const ChatMinimizedActions = ({ unreadCount, onClose }: ChatMinimizedActionsProps) => (
  <span onClick={onClose} className={css.minimizedActions}>
    {unreadCount > 0 && <div className={css.unreaded}>{unreadCount}</div>}
    <Icon name="cross" size="xxs" />
  </span>
);
